import { default as Container } from './TopCustomersSection.container';
import { default as Component } from './TopCustomersSection';
export default Container(Component);
